import { config } from '@config';
import type { FunctionComponent } from 'react';
import { Helmet } from 'react-helmet';

export type HelmetProps = {
  title?: string;
};

export const HelmetWrapper: FunctionComponent<HelmetProps> = (props) => {
  let { title } = props;

  title = [config.app?.brandName, title].filter(Boolean).join(' | ');

  return (
    <Helmet>
      <title>{title}</title>
      <meta
        name="google"
        content="nositelinkssearchbox"
      />
      <meta
        name="robots"
        content="noindex"
      />
    </Helmet>
  );
};
